
import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {AppModule, ShopModule, store, TradeInModule} from "@returns-centre/store";
import { config } from '@/config';
import { ShippingOptionService } from '@/enums';

@Component
export default class TradeInThankYou extends Vue {
    tradeInModule = getModule(TradeInModule, store);
    shopModule = getModule(ShopModule, store);
    appModule = getModule(AppModule, store);
    tradeIn: TradeIn | null = this.tradeInModule.confirmed_trade_in;
    showDropoffPointInfo: boolean = false;
    baseUrl = config.baseUrl;

    get isItCustomOrJGSShippingOption(): boolean {
        if (this.tradeInModule.old_selected_return_carrier_service) {
            return [ShippingOptionService.custom.toString(), ShippingOptionService.JGS.toString()].includes(this.tradeInModule.old_selected_return_carrier_service.service_class);
        }

        return false;
    }

    created() {
        this.tradeInModule.finishTradeIn();
    }

    downloadShippingLabel(labelUrl: string) {
        window.open(labelUrl, '_blank');
    }

    continueShopping() {
        window.location.href = `https://${this.shopModule.shop!.shop_domain}`;
    }
}

